import { render, staticRenderFns } from "./SearchFilterTokens.vue?vue&type=template&id=543a4e36&scoped=true&"
import script from "./SearchFilterTokens.vue?vue&type=script&lang=js&"
export * from "./SearchFilterTokens.vue?vue&type=script&lang=js&"
import style0 from "./SearchFilterTokens.vue?vue&type=style&index=0&id=543a4e36&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "543a4e36",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('543a4e36')) {
      api.createRecord('543a4e36', component.options)
    } else {
      api.reload('543a4e36', component.options)
    }
    module.hot.accept("./SearchFilterTokens.vue?vue&type=template&id=543a4e36&scoped=true&", function () {
      api.rerender('543a4e36', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-2FaxLTpuSJ7Ab/JS/comp/SearchFilterTokens.vue"
export default component.exports